import { defineCoach } from '../../types';
import { PERMISSIONS, canAll, canAny } from '../tasks/access';

/** Issue and send are the buyer's actions, distinct from supplier/receipt states. */
export const C04 = defineCoach({
  id: 'C04',
  version: 1,
  portal: 'tenant',
  titleKey: 'guidance.coaches.C04.title',
  summaryKey: 'guidance.coaches.C04.summary',
  eligible: (ctx) =>
    ctx.portal === 'tenant' &&
    canAny(ctx, PERMISSIONS.orderViewAny, PERMISSIONS.orderViewBranch) &&
    canAll(ctx, PERMISSIONS.orderIssue, PERMISSIONS.orderSend),
  steps: [
    {
      id: 'c04-welcome',
      kind: 'explain',
      page: 'tenant.purchase-orders',
      anchor: null,
      titleKey: 'guidance.coaches.C04.welcome.title',
      bodyKey: 'guidance.coaches.C04.welcome.body',
      route: 'tenant.purchase-orders',
    },
    {
      id: 'c04-open-draft',
      kind: 'await',
      page: 'tenant.purchase-orders',
      anchor: 'tenant.orders.list',
      titleKey: 'guidance.coaches.C04.open-draft.title',
      bodyKey: 'guidance.coaches.C04.open-draft.body',
      until: {
        route: 'tenant.purchase-order',
        probe: { anchor: 'tenant.po.status-dimensions', in: ['draft'] },
      },
    },
    {
      id: 'c04-terms',
      kind: 'explain',
      page: 'tenant.purchase-order',
      anchor: 'tenant.po.lines',
      titleKey: 'guidance.coaches.C04.terms.title',
      bodyKey: 'guidance.coaches.C04.terms.body',
    },
    {
      id: 'c04-status',
      kind: 'explain',
      page: 'tenant.purchase-order',
      anchor: 'tenant.po.status-dimensions',
      titleKey: 'guidance.coaches.C04.status.title',
      bodyKey: 'guidance.coaches.C04.status.body',
    },
    {
      id: 'c04-issue-handoff',
      kind: 'handoff',
      page: 'tenant.purchase-order',
      anchor: ['tenant.po.actions', 'tenant.po.actions-phone'],
      titleKey: 'guidance.coaches.C04.issue-handoff.title',
      bodyKey: 'guidance.coaches.C04.issue-handoff.body',
      consequenceKey: 'guidance.coaches.C04.issue-handoff.consequence',
    },
    {
      id: 'c04-issue',
      kind: 'await',
      page: 'tenant.purchase-order',
      anchor: ['tenant.po.actions', 'tenant.po.actions-phone'],
      titleKey: 'guidance.coaches.C04.issue.title',
      bodyKey: 'guidance.coaches.C04.issue.body',
      until: {
        outcome: 'po.issued',
        route: 'tenant.purchase-order',
        probe: { anchor: 'tenant.po.status-dimensions', in: ['issued', 'sent', 'active'] },
      },
    },
    {
      id: 'c04-send-handoff',
      kind: 'handoff',
      page: 'tenant.purchase-order',
      anchor: ['tenant.po.actions', 'tenant.po.actions-phone'],
      titleKey: 'guidance.coaches.C04.send-handoff.title',
      bodyKey: 'guidance.coaches.C04.send-handoff.body',
      consequenceKey: 'guidance.coaches.C04.send-handoff.consequence',
    },
    {
      id: 'c04-send',
      kind: 'await',
      page: 'tenant.purchase-order',
      anchor: ['tenant.po.actions', 'tenant.po.actions-phone'],
      titleKey: 'guidance.coaches.C04.send.title',
      bodyKey: 'guidance.coaches.C04.send.body',
      until: {
        outcome: 'po.sent',
        route: 'tenant.purchase-order',
        probe: { anchor: 'tenant.po.header', in: ['sent'] },
      },
    },
    {
      id: 'c04-responses',
      kind: 'explain',
      page: 'tenant.purchase-order',
      anchor: 'tenant.po.supplier-responses',
      titleKey: 'guidance.coaches.C04.responses.title',
      bodyKey: 'guidance.coaches.C04.responses.body',
    },
    {
      id: 'c04-versions',
      kind: 'explain',
      page: 'tenant.purchase-order',
      anchor: 'tenant.po.versions',
      titleKey: 'guidance.coaches.C04.versions.title',
      bodyKey: 'guidance.coaches.C04.versions.body',
    },
    {
      id: 'c04-finish',
      kind: 'finish',
      page: 'tenant.purchase-order',
      anchor: null,
      titleKey: 'guidance.coaches.C04.finish.title',
      bodyKey: 'guidance.coaches.C04.finish.body',
    },
  ],
});
